export enum OfficersFiltersTypes {

    SignedDate = 'signedDate',
    Naics = 'naics',
    PscCode = 'pscCode',
    PopState = 'states',
    OfficeName = 'officeName',
    Email = 'email',
    Agency = 'agencyName',

}